import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import AppointmentNotes from "./AppointmentNotes";
import useDebugInformation from "../../../../../../../hooks/useDebugInformation";
import DateSelector from "./DateSelector";
import { ui } from "../../../../../../../interfaces/interfaces";
import AppointmentDate from '../../../../../../../utilities/appointmentDate';
import useCharges from "../../../../../../../hooks/useCharges";
import { useAppSelector } from "@store/hooks";

// namespace constants
const name = "AppointmentTab";

// AppointmentTabProps type
type AppointmentTabProps = {
  parent: string
}


const setGoBackDate = () => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1);
  const appointmentDate = AppointmentDate.changeToValidTimeForDate(tomorrow, "am")
  ui.AppointmentDate = appointmentDate;
  ui.AppointmentTime = "am";
}

const AppointmentTab: React.FC<AppointmentTabProps> = ({ parent }) => {
  const isGoBack = useAppSelector(({ state }) => state.IsAGoBack);
  const isQuote = useAppSelector(({ state }) => state.IsAQuote);
  const debugName = `${parent}▷[${name}]`
  useCharges()

  useDebugInformation(debugName, { debugName })

  React.useEffect(() => {
    if (isGoBack?.state || isQuote) {
      setGoBackDate()
    }
  }, [isGoBack, isQuote])

  return (
    <Box sx={{
      backgroundColor: 'background.paper',
      width: "100%",
      position: "relative",
      minHeight: 160,
    }} >
      <Stack spacing={1}>
        <Paper elevation={4} >
          <Box textAlign="center" sx={{ p: 1 }}>APPOINTMENT DATE</Box>
        </Paper>
        <form noValidate onSubmit={e => e.preventDefault()}>
          <Stack >
            {!isGoBack?.state && !isQuote && <DateSelector parent={debugName} />}
            {(isGoBack?.state || isQuote) && <Typography variant="h4" textAlign="center" >{isQuote ? "Our Quotes team will arrange a time convenient for you" : "No appointment to be requested from customer due to go-back process"}</Typography>}
            {!isGoBack?.state && !isQuote && <AppointmentNotes parent={debugName} />}
          </Stack>
        </form>
      </Stack>
    </Box >
  );
}

AppointmentTab.displayName = name;


export default React.memo(AppointmentTab);